const headingDriverFactory = factoryParams => {
  const { element } = factoryParams;

  return {
    exists: () => !!element,
    getAppearance: () => element.getAttribute('data-appearance'),
    getSize: () => element.getAttribute('data-size'),
    getTagName: () => element.tagName,
    getText: () => element.innerHTML,
    isLight: () => element.getAttribute('data-light') === 'true',
    isMasked: () => element.getAttribute('data-mask') === 'true',
    getId: () => element.getAttribute('data-id'),
  };
};

export default headingDriverFactory;
